import React from 'react';
import './Terms.css';
import { useLocalContext } from '../../context/LocalContext';
import {
  resolveSiteEmail,
  resolveSiteName,
  resolveSitePhone,
} from '../../utils/siteConfig';

const Terms = () => {
  const { webinfo = {} } = useLocalContext();
  const company = resolveSiteName(webinfo);
  const email = resolveSiteEmail(webinfo);
  const phone = resolveSitePhone(webinfo);

  return (
    <div className="terms-wrapper">
      <div className="terms-header">
        <h2>Terms & Conditions</h2>
        <p>
          Read these terms carefully before using the services of <strong>{company}</strong>. They outline your rights, responsibilities, and our commitment to helpful device setup guidance and support.
        </p>
      </div>

      <div className="terms-content">

        <div className="terms-section">
          <h3>1. Agreement Overview</h3>
          <p>
            By using our services, you agree to comply with these Terms & Conditions, including all applicable policies, proposals, or agreements provided by <strong>{company}</strong>.
          </p>
        </div>

        <div className="terms-section">
          <h3>2. Our Services</h3>
          <p>
            We provide guided setup assistance for printers, Wi‑Fi routers/extenders, and related device troubleshooting, including live specialist support when requested. Specific engagements may follow a separate agreement or proposal.
          </p>
        </div>

        <div className="terms-section">
          <h3>3. Client Responsibilities</h3>
          <p>
            Clients should provide accurate information, timely feedback, and necessary access. Delays or incomplete communication may impact project timelines and results.
          </p>
        </div>

        <div className="terms-section">
          <h3>4. Payment Terms</h3>
          <p>
            Payments are due according to the agreed schedule. Late payments may incur interest or suspension of services. All prices exclude applicable taxes unless stated otherwise.
          </p>
        </div>

        <div className="terms-section">
          <h3>5. Ownership & Usage Rights</h3>
          <p>
            Upon full payment, you own the final deliverables. <strong>{company}</strong> retains the right to showcase work in portfolios or case studies unless restricted by NDA.
          </p>
        </div>

        <div className="terms-section">
          <h3>6. Confidentiality & Privacy</h3>
          <p>
            We maintain confidentiality for all client information. Data is never shared without consent or legal requirement. Security standards are strictly followed.
          </p>
        </div>

        <div className="terms-section">
          <h3>7. Performance Disclaimer</h3>
          <p>
            While we apply industry best practices, outcomes such as successful installation, network performance, or device compatibility are not guaranteed, as results depend on hardware, firmware, networks, and user environment.
          </p>
        </div>

        <div className="terms-section">
          <h3>8. Project Cancellation</h3>
          <p>
            Either party may terminate the project with written notice. Completed work up to cancellation date must be paid. We reserve the right to cancel projects for non-payment or violations.
          </p>
        </div>

        <div className="terms-section">
          <h3>9. Limitation of Liability</h3>
          <p>
            <strong>{company}</strong> is not liable for indirect losses or third-party disruptions. Liability is limited to the total fees paid for the service.
          </p>
        </div>

        <div className="terms-section">
          <h3>10. Legal Jurisdiction</h3>
          <p>
            These Terms are governed by Indian law. Disputes will be resolved in {webinfo.addressCity || 'our operational jurisdiction'}.
          </p>
        </div>

        <div className="terms-section">
          <h3>11. Revisions & Updates</h3>
          <p>
            We may update these Terms periodically. Continued use of services indicates acceptance of the latest version.
          </p>
        </div>

        <div className="terms-section">
          <h3>12. Contact Us</h3>
          <p>
            For any questions regarding these terms, reach out at <strong>{email}</strong> or call <strong>{phone}</strong>.
          </p>
        </div>

        <div className="contact-info">
          <a href="/contact">Reach Out to Us</a>
        </div>

      </div>
    </div>
  );
};

export default Terms;
